import { FormGroup } from '@angular/forms';
import { BaseClass } from './base';

export class Travel extends BaseClass {
	
   list:any;
   id: Number;
   user_id: Number;
   summary_list = [];
   booking_details_list = [];
   booking_details_temp = [];
   itineraries:any;
   date_filed:any;
   date_of_travel: String;
   travel_authorization_no: Number;
   travel_authorization_id: Number;
   complete_name: String;
   employee_id_no: Number;
   position: String;
   department: String;
   area_covered: String;
   payroll_acct_no: Number;
   travel_type: String;
   purpose: String;
   location: String;
   nature: String;
   inclusive_date_from: any;
   inclusive_date_to: any;
   currency: any;
   amount: String;
   charged_to: String;
   booked_by: String;
   bill_to: String;
   ts_details: String;
   user: any;
   transportation_no: String;
   origin: String;
   origin_city_municipality: String;
   origin_barangay: String;
   misc_breakdown: String;
   destination: String;
   destination_city_municipality: String;
   destination_barangay: String;
   estimated_date_time_of_departure: any;
   estimated_date_time_of_arrival: any;
   baggage_allowance: Number;
   cash_for_reimbursement: Number = 0;
   cash_return: Number = 0;
   amount_for_reimbursement: Number = 0;
   is_draft: boolean;
   status_id: Number;
   first_approved_by: Number;
   itinerary_date: any;
   fromDatePicker: any;
   special_approvers: any;
   is_special_instruction: boolean;
   totalPortFee: number = 0;
   totalLodging: number = 0;
   totalDiem: number = 0;
   totalMeal: number = 0;
   totalRepre: number = 0;
   totalMisc: number = 0;
   totalExpenses: number = 0;
   totalTranspo: number = 0;
   totalLiquidation: number = 0;
   totalReimburse: number = 0;

   constructor(data?: any ) {
      super();
      this.list = data || '';
      this.id = data.id || '';
      this.user_id = data.user_id || '';
      this.date_filed = data.date_filed || '';
      this.date_of_travel = data.date_of_travel || '';
      this.travel_authorization_no = data.travel_authorization_no || '';
      this.complete_name = data.complete_name || '' ;
      this.employee_id_no = data.employee_id_no || '';
      this.position = data.position || '';
      this.department = data.department || '';
      this.area_covered = data.area_covered || '';
      this.payroll_acct_no = data.payroll_acct_no || '';
      this.travel_type = data.travel_type || '';
      this.misc_breakdown = data.misc_breakdown || '';
      this.purpose = data.purpose || '';
      this.location = data.location || '';
      this.nature = data.nature || '';
      this.cash_for_reimbursement = data.cash_for_reimbursement || '';
      this.cash_return = data.cash_return || '';
      this.amount_for_reimbursement = data.amount_for_reimbursement || '';
      this.user = data.user || '';
      if (typeof data.travel_summary !== "undefined") {
         this.inclusive_date_from = data.travel_summary.inclusive_date_from || '';
         this.inclusive_date_to = data.travel_summary.inclusive_date_to || '';
         this.travel_authorization_id = data.travel_summary.id || '';
      }
      this.currency = data.currency || '';
      this.amount = data.amount || '';
      this.charged_to = data.charged_to || '';
      this.booked_by = data.booked_by || '';
      this.bill_to = data.bill_to || '';
      this.ts_details = data.ts_details || '';
      this.transportation_no = data.transportation_no || '';
      this.origin = data.origin || '';
      this.origin_city_municipality = data.origin_city_municipality || '';
      this.origin_barangay = data.origin_barangay || '';
      this.destination = data.destination || '';
      this.destination_city_municipality = data.destination_city_municipality || '';
      this.destination_barangay = data.destination_barangay || '';
      this.estimated_date_time_of_departure = data.estimated_date_time_of_departure || '';
      this.estimated_date_time_of_arrival = data.estimated_date_time_of_arrival || '';
      this.baggage_allowance = data.baggage_allowance || '';
      this.is_draft = (data.status_id == 0)? true : false || false;
      this.status_id = data.status_id || false;
      this.first_approved_by = data.first_approved_by || '';
      this.itinerary_date = '';
      this.fromDatePicker = '';
      this.special_approvers = data.special_instruction || '';
      this.is_special_instruction = (data.special_instruction_id) ? true : false || false;
   
   }

   /**
    * Travel Itinerary 
    * compute total expenses
    * Transport Cost
    * Acommodation
    * Per Diem
    * Meal
    * Representation
    * Miscellaenoues
    */
   getTotal() {
      this.totalExpenses = 0;
      if (this.itineraries) {
        this.itineraries.forEach(element =>{
            this.totalPortFee += Number(element.transportation);
            this.totalLodging +=  Number(element.accommodation_cost);
            this.totalDiem += Number(element.per_diem);
            this.totalMeal += Number(element.meal);
            this.totalTranspo += Number(element.total_transportation_cost);
   
            if (element.itinerary_miscellaneous) {
               element.itinerary_miscellaneous.forEach((el,i) => {
                  if (el.miscellaneous.name == "Representation") {
                     this.totalRepre += el.amount;
                  }
                  if (el.miscellaneous.name == "Miscellaneous") {
                     this.totalMisc  += el.amount;
                  }
               });
            }
   
            if (element.travel_itinerary_liquidation) {
               this.totalLiquidation += Number(element.travel_itinerary_liquidation.total_actual_expense);
            }
            if (element.travel_itinerary_reimbursement) {
               this.totalReimburse += Number(element.travel_itinerary_reimbursement.total_actual_expense);
            }
            this.totalExpenses += Number(element.total_expense);
         });
      }
   }

   clearTotal() {
      this.totalPortFee = 0;
      this.totalLodging = 0;
      this.totalDiem = 0;
      this.totalMeal = 0;
      this.totalRepre = 0;
      this.totalMisc = 0;
      this.totalTranspo = 0;
      this.totalExpenses = 0;
      this.totalLiquidation = 0;
      this.totalReimburse = 0;
   }

   getViewTotal() {
      this.list.travel_authorization.travel_summary.travel_summary_details.forEach(element =>{
         this.totalPortFee += element.transportation;
         this.totalLodging +=  element.accommodation_cost;
         this.totalDiem += element.per_diem;
         this.totalMeal += element.meal;
      });
   }

   getTotalView(){
      this.list.travel_authorization.travel_summary.travel_summary_details.forEach(element =>{
         this.totalPortFee += element.transportation;
         this.totalLodging +=  element.accommodation_cost;
         this.totalDiem += element.per_diem;
         this.totalMeal += element.meal;
         this.totalRepre += element.representation;
         this.totalMisc += element.miscellaneous;
         this.totalExpenses += element.total_expense;
      });
   }
   

   /**
    * Booking Itinerary 
    * @param res Data Object
    */
   setBooking(res) {
      this.booking_details_list.push(res);
      this.booking_details_temp.push(res);
   }

   /**
    * Summary Itinerary
    * @param res Data Object
    */
   setSummaryList(res) {
      this.summary_list.push(res);
   }

   getSummaryList() {
      return this.summary_list;
   }

   getRequired() {
      return {
         date_filed: 'This field is required',
         date_of_travel: 'This field is required',
         travel_authorization_no: 'This field is required',
         complete_name: 'This is required',
         employee_id_no: 'This field is required',
         position: 'This field is required',
         department: 'This field is required',
         area_covered: 'This field is required',
         payroll_acct_no:  'This field is required',
         travel_type: 'This field is required',
         purpose: 'This field is required',
         location:'This field is required',
         nature: 'This field is required',
         inclusive_date_from: 'This field is required',
         inclusive_date_to:'This field is required',
         currency: 'This field is required',
         amount: 'This field is required',
         charged_to:  'This field is required',
         booked_by:  'This field is required',
         bill_to:  'This field is required',
         ts_details:  'This field is required',
         transportation_no:  'This field is required',
         origin:  'This field is required',
         origin_city_municipality:  'This field is required',
         origin_barangay:  'This field is required',
         destination:  'This field is required',
         destination_city_municipality:  'This field is required',
         destination_barangay:  'This field is required',
         estimated_date_time_of_departure:  'This field is required',
         estimated_date_time_of_arrival:  'This field is required',
         baggage_allowance:  'This field is required',
         is_draft:  'This field is required',
         travel_summary_id:  'This field is required',
         travel_authorization_id:  'This field is required',
         travel_date:  'This field is required',
         activity:  'This field is required',
         mode_of_transportation:  'This field is required',
         representation:  'This field is required',
         miscellaneous:  'This field is required',
         transportation:  'This field is required',
         accommodation_cost:  'This field is required',
         per_diem:  'This field is required',
         meal:  'This field is required'
      }
   }

}